export default {
  list: (state) => {
    return state.list;
  },
};
